import * as React from "react"
import type { SVGProps } from "react"
const SvgHeading1 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M6 17a1 1 0 0 1-.71-.29A1 1 0 0 1 5 16V8q0-.42.29-.71A1 1 0 0 1 6 7q.42 0 .71.29.3.29.29.71v3h4V8q0-.42.29-.71A1 1 0 0 1 12 7q.42 0 .71.29.3.29.29.71v8q0 .42-.29.71A1 1 0 0 1 12 17a1 1 0 0 1-.71-.29A1 1 0 0 1 11 16v-3H7v3q0 .42-.29.71A1 1 0 0 1 6 17m12 0a1 1 0 0 1-.71-.29A1 1 0 0 1 17 16V9h-1a1 1 0 0 1-.71-.29A1 1 0 0 1 15 8q0-.42.29-.71A1 1 0 0 1 16 7h2q.42 0 .71.29.3.29.29.71v8q0 .42-.29.71A1 1 0 0 1 18 17" />
  </svg>
)
export default SvgHeading1
